<template>
  <div>
    <AppHeader />
    <main>
      <div class="wrap">
        <article class="doc-page">
          <slot />
        </article>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
</script>
